<cdk-accordion-item
	[expanded]="expanded()"
	#accordionItem="cdkAccordionItem"
	class="assignment-accordion-item"
	[class.temporary]="temporary()"
	[class.no-header]="hideHeader()"
>
	@if (!hideHeader()) {
		<button
			class="assignment-accordion-item-header"
			[class.toggle-enabled]="showToggle() && !lockOpen()"
			(click)="toggleAccordion($event, accordionItem)"
			tabindex="0"
			[attr.id]="'accordion-header-' + assignmentId()"
			[attr.aria-expanded]="accordionItem.expanded"
			[attr.aria-controls]="'accordion-body-' + assignmentId()"
		>
			<div class="accordion-header-inner grid" [class.details-restricted]="showRestrictionIndicator()">
				@if (showToggle() && !lockOpen()) {
					@if (accordionItem.expanded) {
						<mat-icon aria-hidden="true">expand_less</mat-icon>
					} @else {
						<mat-icon aria-hidden="true">expand_more</mat-icon>
					}
				} @else {
					<div><!-- Spacer for content alignment --></div>
				}
				<div class="content" [matTooltip]="disableTitleNavigation() ? disableTitleNavigationTooltip() : ''">
					<button
						(click)="routeToAssignment($event)"
						[class.accordion-link]="!disableTitleNavigation()"
						[disabled]="disableTitleNavigation()"
					>
						<span class="assignment-title">
							<ng-content select="accordion-title"></ng-content>
						</span>
						<span class="date">
							<ng-content select="accordion-date"></ng-content>
						</span>
					</button>
				</div>
				@if (chipLabel()) {
					<lvr-chip [name]="chipLabel()!" [labelKey]="'assignment.additional.responsible'"></lvr-chip>
				}
				<div class="accordion-actions">
					<ng-content select="accordion-button"></ng-content>
				</div>
			</div>
		</button>
	}
	@if (accordionItem.expanded) {
		<div
			class="assignment-accordion-item-body"
			role="region"
			[style.display]="accordionItem.expanded ? '' : 'none'"
			[attr.id]="'accordion-body-' + assignmentId()"
			[attr.aria-labelledby]="hideHeader() ? null : 'accordion-header-' + assignmentId()"
		>
			<ng-content></ng-content>
		</div>
	}
</cdk-accordion-item>
